import React, { ReactNode } from "react";
import {
    Box,
  } from "@chakra-ui/react";

  export default function Main({ children }: { children: ReactNode }): JSX.Element {
    return (
      <Box
        p={{ base: 5, md:6, lg: 2 }}
        ps={{ lg: 12 }}
        pe={{ lg: 12 }}
        minH={{ base: "calc(100vh - 120px)", lg: "calc(100vh - 140px)" }}
      >
        {children}
      </Box>
    );
}